import { User } from "./user";
var Company = /** @class */ (function () {
    function Company(name, email, user) {
        this.name = name;
        this.email = email ? email.toLowerCase() : "";
        if (!user) {
            this.user = new User();
        }
    }
    Object.defineProperty(Company.prototype, "sharedTokens", {
        get: function () {
            return this._sharedTokens;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "hostSiteName", {
        get: function () {
            return this._hostSiteName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "email", {
        get: function () {
            return this._email;
        },
        set: function (value) {
            this._email = value ? value.toLowerCase() : "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "user", {
        get: function () {
            return this._user;
        },
        set: function (value) {
            this._user = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "clientCount", {
        get: function () {
            return this._clientCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "tokenCount", {
        get: function () {
            return this._tokenCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "sendAssessmentsCompleteNotifications", {
        get: function () {
            return this._sendAssessmentsCompleteNotifications;
        },
        set: function (v) {
            this._sendAssessmentsCompleteNotifications = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "sendNotificationsToPrimaryContact", {
        get: function () {
            return this._sendNotificationsToPrimaryContact;
        },
        set: function (v) {
            this._sendNotificationsToPrimaryContact = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "disableShopRegisteredUsers", {
        get: function () {
            return this._disableShopRegisteredUsers;
        },
        set: function (v) {
            this._disableShopRegisteredUsers = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "sendNotificationsCopyToRegularUsers", {
        get: function () {
            return this._sendNotificationsCopyToRegularUsers;
        },
        set: function (v) {
            this._sendNotificationsCopyToRegularUsers = v;
        },
        enumerable: true,
        configurable: true
    });
    return Company;
}());
export { Company };



// WEBPACK FOOTER //
// ./src/app/shared/models/company.ts.pre-build-optimizer.js